import ServicePage from '@/pages/services/ServicePage';

const content = {
  eyebrow: 'Arquitectura y Cloud',
  title: 'Arquitectura preparada para crecer.',
  subtitle:
    'Diseñamos arquitecturas modernas, escalables y mantenibles para productos digitales y sistemas empresariales.',
  tags: ['SaaS multi-tenant', 'Docker', 'Cloud', 'APIs', 'Seguridad', 'Observabilidad'],
  blocks: [
    {
      icon: 'ri-git-branch-line',
      title: 'Arquitectura de software',
      desc: 'Decisiones de diseño que preparan tu producto para crecer y evolucionar.',
    },
    {
      icon: 'ri-stack-line',
      title: 'SaaS multi-tenant',
      desc: 'Arquitecturas que sirven a múltiples clientes de forma aislada y eficiente.',
    },
    {
      icon: 'ri-box-3-line',
      title: 'Docker',
      desc: 'Contenedores para entornos reproducibles y despliegues consistentes.',
    },
    {
      icon: 'ri-cloud-line',
      title: 'Cloud e infraestructura',
      desc: 'Diseño y despliegue sobre infraestructura cloud moderna.',
      items: ['Cloud', 'VPS', 'Linux'],
    },
    {
      icon: 'ri-links-line',
      title: 'Diseño de APIs',
      desc: 'APIs limpias, versionadas y documentadas para integraciones duraderas.',
    },
    {
      icon: 'ri-shield-keyhole-line',
      title: 'Seguridad y observabilidad',
      desc: 'Prácticas de seguridad y monitoreo para operar con confianza.',
      items: ['Seguridad', 'Escalabilidad', 'Observabilidad'],
    },
  ],
  highlightTitle: 'Pensamos en crecimiento, mantenimiento e integración.',
  highlightDesc:
    'Una buena arquitectura no se nota al principio; se nota cuando el producto crece sin romperse.',
};

export default function Arquitectura() {
  return <ServicePage content={content} />;
}